import {
  PROCESS_CARD_CREATE,
  PROCESS_CARD_UPDATE,
  PROCESS_CARD_FETCH,
  ROUTECARD_CARD_UPDATE,
  ROUTECARD_CARD_CREATE,
  ROUTECARD_FETCH,
  ROUTECARD_START_FINISH,
  ROUTECARD_PROCESS_START,
  ROUTECARD_PROCESS_FINISH,
} from "../config";
import { get, post } from "./apiHelper";

export const createProcessCard = (submissionData) =>
  post(PROCESS_CARD_CREATE, submissionData);

export const updateProcessCard = (submissionData, id) =>
  post(`${PROCESS_CARD_UPDATE}${id}`, submissionData);

export const fetchProcessCard = ({ id }) => get(`${PROCESS_CARD_FETCH}${id}`);

export const createRouteCard = (submissionData) =>
  post(ROUTECARD_CARD_CREATE, submissionData);

export const updateRouteCard = (id, submissionData) =>
  post(`${ROUTECARD_CARD_UPDATE}${id}`, submissionData);

export const fetchRouteCard = (id) => get(`${ROUTECARD_FETCH}${id}`);

export const startRouteCard = (routeCardId) =>
  post(`${ROUTECARD_START_FINISH}${routeCardId}`, {
    start: "started",
  });

export const finishRouteCard = (routeCardId) =>
  post(`${ROUTECARD_START_FINISH}${routeCardId}`, {
    finish: "finished",
  });

export const startRouteCardProcess = (
  routeCardId,
  serialNo,
  allocatedWorkStation,
  startTime,
) =>
  post(ROUTECARD_PROCESS_START, {
    route_card_id: routeCardId,
    serial_no: serialNo,
    allocated_work_station: allocatedWorkStation,
    ...(startTime ? { start_time: startTime } : {}),
  });

export const finishRouteCardProcess = (
  routeCardId,
  serialNo,
  timeTaken,
  startTime,
) =>
  post(ROUTECARD_PROCESS_FINISH, {
    route_card_id: routeCardId,
    serial_no: serialNo,
    time_taken: timeTaken,
    ...(startTime ? { start_time: startTime } : {}),
  });
